import React from 'react';
import {useState,useEffect} from 'react';
import EOP1 from './EOP1'
import EOP2 from './EOP2'
import swal from 'sweetalert';
import { useNavigate } from 'react-router-dom';
import Dashboard from './Dashboard';


function Closeapp (){

const navigate = useNavigate();

const [flag,setFlag]=useState(false)

  useEffect(()=>{
    
    confLogout()
  })

const userInfo = localStorage.getItem('user-info');


function confLogout(){

  if (userInfo ) {
    swal({
      title: "Are you sure?",
      text: "Once logout, you will not be able to access menu items",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then((confirm) => {
      if (confirm)
      {
        logout();
      }
      else
      {
        swal("Please carry on!");
     //   navigate('/Dashboard')
      }

    });
  }
  else{
   // logout();
  }
}

  function logout(){
   // alert('logout')
   
    localStorage.clear();
    sessionStorage.clear();
    localStorage.removeItem('token');
    localStorage.removeItem('user-info');
    localStorage.removeItem('user-role');
    localStorage.removeItem('user-id');
    localStorage.removeItem('user-id');
    navigate('/');
    window.location.reload();
    
  }


const ShowPage = (userInfo)=>{
    return(<Dashboard />)
}


return(
<>
    <ShowPage />
</>
);
}

export default Closeapp;

